/**
 * Auto-detect banner background brightness and adjust text color accordingly
 */
class BannerTextContrast {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM and images to load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.analyzeBanners());
    } else {
      this.analyzeBanners();
    }

    // Re-analyze on window load to ensure images are fully loaded
    window.addEventListener('load', () => this.analyzeBanners());
  }

  analyzeBanners() {
    const banners = document.querySelectorAll('.banner');
    banners.forEach(banner => this.processBanner(banner));
  }

  processBanner(banner) {
    const img = banner.querySelector('.banner__media img');
    const heading = banner.querySelector('.banner__heading.inline-richtext');
    
    if (!img || !heading) return;

    // If image is already loaded, analyze immediately
    if (img.complete && img.naturalHeight !== 0) {
      this.analyzeImage(img, banner, heading);
    } else {
      // Wait for image to load
      img.addEventListener('load', () => {
        this.analyzeImage(img, banner, heading);
      });
    }
  }

  analyzeImage(img, banner, heading) {
    try {
      // Create canvas to analyze image
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Set canvas size (smaller for performance)
      const sampleSize = 100;
      canvas.width = sampleSize;
      canvas.height = sampleSize;
      
      // Draw image to canvas
      ctx.drawImage(img, 0, 0, sampleSize, sampleSize);
      
      // Get image data
      const imageData = ctx.getImageData(0, 0, sampleSize, sampleSize);
      const data = imageData.data;
      
      // Calculate average brightness
      let totalBrightness = 0;
      let pixelCount = 0;
      
      // Sample every 4th pixel for performance
      for (let i = 0; i < data.length; i += 16) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        
        // Calculate perceived brightness using luminance formula
        const brightness = (0.299 * r + 0.587 * g + 0.114 * b);
        totalBrightness += brightness;
        pixelCount++;
      }
      
      const averageBrightness = totalBrightness / pixelCount;
      
      // Apply appropriate text color based on brightness
      if (averageBrightness > 180) {
        // Light background - use black text
        banner.setAttribute('data-bg-brightness', 'light');
        heading.style.setProperty('color', '#423e3f', 'important');
      } else {
        // Darker background - use cream text
        banner.setAttribute('data-bg-brightness', 'darker');
        heading.style.setProperty('color', '#f8f5e7', 'important');
      }
      
      console.log(`Banner brightness: ${Math.round(averageBrightness)} - Using ${averageBrightness > 128 ? 'black' : 'cream'} text`);
      
    } catch (error) {
      console.warn('Could not analyze banner image brightness:', error);
      // Fallback to cream text
      heading.style.setProperty('color', '#f8f5e7', 'important');
    }
  }
}

// Initialize when script loads
new BannerTextContrast();
